/**
 * Parse a date string in DD/MM/YYYY format and add N days.
 * Also accepts ISO / any format parseable by `new Date()`.
 * Returns DD/MM/YYYY or null if the input is invalid.
 */
export const addDays = (dateStr, days) => {
  if (!dateStr) return null;
  try {
    const parts = String(dateStr).split("/");
    const date =
      parts.length === 3
        ? new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]))
        : new Date(dateStr);
    if (isNaN(date)) return null;
    date.setDate(date.getDate() + days);
    const dd = String(date.getDate()).padStart(2, "0");
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    return `${dd}/${mm}/${date.getFullYear()}`;
  } catch {
    return null;
  }
};
